import React from "react";

/**
 * ToggleSwitch - A reusable toggle/switch button component
 * Used by both Toggle and NotificationRow components
 */
export default function ToggleSwitch({ id, checked, onChange, ariaLabel }) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex items-center h-6 w-11 shrink-0 cursor-pointer rounded-full border border-border-strong transition ${
        checked ? "bg-primary" : "bg-surface-muted"
      }`}
      aria-label={ariaLabel}
    >
      <span
        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-surface-elevated shadow transition ${
          checked ? "translate-x-5" : "translate-x-0"
        }`}
      />
    </button>
  );
}
